import { useMutation } from "@tanstack/react-query";
import authApi from "../../api/authApi";

export const useResetPasswordConfirm = () => {
    return useMutation({
        mutationFn: (data: { token: string; newPassword: string }) =>
            authApi.resetPasswordConfirm(data.token, data.newPassword),
    });
};